export default __webpack_public_path__ + "static/media/9-neutral-face_1f610.3e17ec53.png";